import math from "@/util/math";

export class ClickElementCoordinatesManager {
  constructor({event = {}, element = {}}) {
    this.event = event;
    this.element = element;
  }

  get coordinatesOnElementInPercent() {
    return {
      x: this._getXCoordinateInPercent(),
      y: this._getYCoordinateInPercent(),
    };
  }

  _getXCoordinateInPercent() {
    return math.numberRoundTo({ number: (this.event.clickElementCoordinates.x * 100 / this.element.width), roundTo: 2});
  }

  _getYCoordinateInPercent() {
    return math.numberRoundTo({ number: this.event.clickElementCoordinates.y * 100 / this.element.height, roundTo: 2});
  }

}

export class HtmlEvent {
  constructor(e = {}) {
    this.event = e;
  }

  get clickElementCoordinates() {
    return {
      x: this.event.offsetX,
      y: this.event.offsetY,
    };
  }
}

export class HtmlElement {
  constructor(el = {}) {
    this.el = el;
  }

  get width() {
    return this.el.offsetWidth;
  }

  get height() {
    return this.el.offsetHeight;
  }
}
